// ============================================================
// SV Audio Player — Bridges (lyrics, etc.)
// ============================================================
// Bridges from the core player to other systems:
// - synced lyrics (lyrics-sync.js)
// (visualizer could join later)
import { initLyricsSync } from "./lyrics-sync.js";

// Local controller for synced lyrics on the current page.
// This mirrors what you had in audio-player.js.
let __lyricsSyncController = null;

export function reinitLyricsSyncForCurrentPage(audioElementOverride) {
  const audioElement =
    audioElementOverride ||
    (window.SVPlayer && window.SVPlayer.audioElement) ||
    document.getElementById("audioElement");

  if (!audioElement) {
    console.warn("[Lyrics] No audio element available for lyrics sync.");
    if (
      __lyricsSyncController &&
      typeof __lyricsSyncController.destroy === "function"
    ) {
      __lyricsSyncController.destroy();
    }
    __lyricsSyncController = null;
    return;
  }

  const container = document.querySelector(
    '.lyrics-section .lyrics-static[data-lyrics-mode="synced"]'
  );

  // If this page has no synced lyrics, tear down any previous listeners
  if (!container) {
    if (
      __lyricsSyncController &&
      typeof __lyricsSyncController.destroy === "function"
    ) {
      __lyricsSyncController.destroy();
    }
    __lyricsSyncController = null;
    return;
  }

  // NEW: only enable synced lyrics when this page's song matches the player
  const pageTrackSlugRaw =
    container.getAttribute("data-track-slug") ||
    container.getAttribute("data-song-slug") ||
    null;

  const currentTrack =
    window.SVPlayer && typeof window.SVPlayer.getCurrentTrack === "function"
      ? window.SVPlayer.getCurrentTrack()
      : null;

  const currentSlugRaw =
    currentTrack &&
    (currentTrack.slug || currentTrack.songSlug || currentTrack.id || null);

  const pageTrackSlug = pageTrackSlugRaw
    ? String(pageTrackSlugRaw).toLowerCase()
    : null;
  const currentTrackSlug = currentSlugRaw
    ? String(currentSlugRaw).toLowerCase()
    : null;

  // If something *is* playing and it's not this song → no synced lyrics
  if (currentTrackSlug && pageTrackSlug && currentTrackSlug !== pageTrackSlug) {
    if (
      __lyricsSyncController &&
      typeof __lyricsSyncController.destroy === "function"
    ) {
      __lyricsSyncController.destroy();
    }
    __lyricsSyncController = null;
    return;
  }

  // Tear down previous controller before wiring a new one
  if (
    __lyricsSyncController &&
    typeof __lyricsSyncController.destroy === "function"
  ) {
    __lyricsSyncController.destroy();
  }

  __lyricsSyncController = initLyricsSync({
    audioElement,
    container,
  });
}